import { patchState, signalStore, withHooks, withMethods } from "@ngrx/signals";
import { setAllEntities, setEntity, withEntities } from "@ngrx/signals/entities";
import { setFulfilled, setPending, withRequestStatus } from "../extensions/request-status.feature";
import { inject } from "@angular/core";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { Observable, pipe, switchMap, tap } from "rxjs";
import { ApiQuestsService } from "../../services/api-quests.service";
import { QuestScheduleViewModel } from "@playcharge/common/models/backend/quests/backoffice/quest-schedule-view-model";
import { QuestScheduleCreateModel } from "@playcharge/common/models/backend/quests/backoffice/quest-schedule-create-model";
import { QuestScheduleEditModel } from "@playcharge/common/models/backend/quests/backoffice/quest-schedule-edit-model";

export type QuestSchedulesStore = InstanceType<typeof QuestSchedulesStore>;

export const QuestSchedulesStore = signalStore(
    { providedIn: "root", protectedState: false },
    withEntities<QuestScheduleViewModel>(),
    withRequestStatus(),
    withMethods((store, apiQuestsService = inject(ApiQuestsService)) => ({
        loadSchedules: rxMethod<void>(
            pipe(
                tap(() => patchState(store, setPending())),
                switchMap(() => {
                    return apiQuestsService.getSchedules().pipe(
                        tap((schedules) => {
                            patchState(store, setAllEntities(schedules));
                            patchState(store, setFulfilled());
                        }),
                    );
                }),
            ),
        ),
        createSchedule(model: QuestScheduleCreateModel): Observable<QuestScheduleViewModel> {
            return apiQuestsService.createSchedule(model).pipe(
                tap((schedule) => {
                    patchState(store, setEntity(schedule));
                }),
            );
        },
        editSchedule(model: QuestScheduleEditModel): Observable<QuestScheduleViewModel> {
            return apiQuestsService.editSchedule(model).pipe(
                tap((schedule) => {
                    patchState(store, setEntity(schedule));
                }),
            );
        },
    })),
    withHooks((store) => ({
        onInit: () => {
            store.loadSchedules();
        },
    })),
);
